import { PermitApplicationClient } from '@src/permits/services/PermitApplicationClient';
import { useMutation } from '@tanstack/react-query';

export enum DuplicationTrigger {
  REORDER = 'REORDER',
  AMEND = 'AMEND',
  MODIFY = 'MODIFY',
}

interface Props {
  permitApplicationId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useDuplicatePermitAsNew = ({
  permitApplicationId,
  onError,
  onSuccess,
}: Props) => {
  const { mutate, isPending } = useMutation({
    mutationFn: ({ trigger }: { trigger: DuplicationTrigger }) =>
      PermitApplicationClient.duplicateAsNew({
        permitApplicationId,
        trigger,
      }),
    onSuccess,
    onError,
  });

  return {
    duplicateAsNew: mutate,
    isPending,
  };
};
